import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner'; // Importa lo spinner

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    // 1. Se stiamo ancora caricando (controllando la sessione), mostra lo spinner
    if (loading) {
        return <LoadingSpinner fullPage={true} />;
    }

    // 2. Se il caricamento è finito e non c'è utente, reindirizza al login
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // 3. Se l'utente è autenticato, mostra la pagina richiesta
    return children;
};

export default ProtectedRoute;